import React from 'react'
import { connect } from 'react-redux';
import { Select } from 'antd';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';

interface StateProps {
  language: string
}
interface DispatchProps { }
interface Props extends StateProps, DispatchProps {
  initialLevel: number,
  onChangeHandler: (level: number) => void
}

function SelectLevel(props: Props) {
  return (
    <Select
      defaultValue={props.initialLevel}
      onChange={(value) => props.onChangeHandler(value)}
    >
      {[1, 2].map((item) => {
        return (
          <Select.Option
            value={item}
            key={item}
          >
            {localization('level', props.language) + item}
          </Select.Option>
        );
      })}
    </Select>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state)
  }
}
const mapDispatchToProps = {}

const ConnectedSelectLevel = connect(mapStateToProps, mapDispatchToProps)(SelectLevel);
export { ConnectedSelectLevel as SelectLevel };